const TEAM_FINVISE_ADMIN = 1;
const TEAM_VALUER = 2;
const TEAM_RETAIL = 3;

export default {
    TEAM_FINVISE_ADMIN,
    TEAM_VALUER,
    TEAM_RETAIL
}